module.exports = __webpack_public_path__ + "static/img/putcontent_3.1bfee74.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/putcontent_3.png
// module id = exyK
// module chunks = 1